import { FC, ReactNode } from 'react';

import { useInitializeTranslations } from '@telialt/common-cms/src/useTranslations';

import { useMaintenanceData } from '../../hooks/useMaintenanceData';
import { NAVIGATION_TEST_IDS } from '../../test-ids';
import { Navigation } from '../Navigation';
import { HeaderSkeleton } from './EmptyNavbar.styles';

type Props = { customContent?: ReactNode };

export const EmptyNavbar: FC<Props> = ({ customContent }) => {
    const { t } = useInitializeTranslations();

    const { data: maintenanceData } = useMaintenanceData();

    if (!t) {
        return <HeaderSkeleton data-test={NAVIGATION_TEST_IDS.SKELETON} />;
    }

    return <Navigation maintenance={maintenanceData} customContent={customContent} />;
};
